import { FC } from 'react';
import { Button, Flex } from '@qga/roo-ui/components';
import * as track from 'lib/gaTracking/cancelBookingPageEvents';
import { useCancellationQuote } from '../CancellationQuoteProvider';
import { GA } from 'types';
import sendGAEvent from 'utils/sendGAEvent';

interface ConfirmationButtonProps {
  [key: string]: any;
}

const ConfirmationButton: FC<ConfirmationButtonProps> = (props) => {
  const { cancellationState, accept } = useCancellationQuote();

  const onClick = () => {
    track.confirmButtonSelected();
    accept();
    sendGAEvent({
      type: GA.EventType.CTA_CLICK,
      itemType: GA.ItemType.BUTTON,
      itemText: 'Confirm Cancellation',
    });
  };

  return (
    <Flex flexDirection="column" width={['100%', 'auto']}>
      <Button {...props} mb={1} disabled={cancellationState !== 'QUOTED'} variant="primary" onClick={onClick}>
        Confirm Cancellation
      </Button>
    </Flex>
  );
};

export default ConfirmationButton;
